export enum ModalMutations {
	SHOW_MODAL = "showModal",
	CLOSE_MODAL = "closeModal",
	SHOW_NOTIFICATION = "showNotification"
}